import noop from 'lodash/noop'
import Script from 'next/script'
import React, { useContext } from 'react'

import { MetadataContext } from '@Globals/Metadata'

// TODO: replace with wrappers or add TypeScript union types
export const ga = (...args: any) => {
  const func = (window as any).ga || noop

  return func(...args)
}

export const AnalyticsInitialize = () => (
  <Script id="analytics-init" strategy="afterInteractive">
    {`
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();/*a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)*/
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    `}
  </Script>
)

export const AnalyticsSetup = () => {
  const { store } = useContext(MetadataContext)

  return (
    <Script id="analytics-setup" strategy="afterInteractive">
      {`
        (function(){
          function getCookie(c_name) {
            if (document.cookie.length > 0) {
              c_start = document.cookie.indexOf(c_name + "=");
              if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start, c_end));
              }
            }
            return "";
          }

          var userID = getCookie('th_uid');

          ga(
            'create',
            'UA-54197020-1',
            {
              allowLinker: true,
              clientId: userID,
              cookieUpdate: false,
              name: 'master',
              storage: 'none'
            }
          );
          ga('master.require', 'displayfeatures');
          ga('master.require', 'linker');
          ga('master.linker:autoLink', ['live.adyen.com']);

          ga(
            'create',
            '${store?.config?.analyticsTrackingID}',
            {
              clientId: userID,
              cookieUpdate: false,
              name: 'local',
              siteSpeedSampleRate: 1,
              storage: 'none'
            }
          );
          ga('local.require', 'displayfeatures');
        })();
      `}
    </Script>
  )
}

export const AnalyticsPageView = () => (
  <Script id="analytics-pageview" strategy="afterInteractive">
    {`
      ga('master.send', 'pageview');
      ga('local.send', 'pageview');
    `}
  </Script>
)
